import React from 'react'
import { Icon } from '~/types'
import { icons } from '~/utils'

export const Folder: React.FunctionComponent<Icon.Props> = ({ mode = 'light', filled = false }) => {
  const color = icons.getIconColor(mode)

  return filled ? (
    <svg width="12px" height="12px" viewBox="0 0 20 20" fill={color} className="folder">
      <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path>
    </svg>
  ) : (
    <svg width="12px" height="12px" fill="none" viewBox="0 0 24 24" stroke={color} className="folder">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
      ></path>
    </svg>
  )
}

export default Folder
